import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section className="w-full bg-cream py-20 md:py-28" data-id="element-213">
      <div className="max-w-5xl mx-auto px-6 md:px-8" data-id="element-214">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-215">
          <h2 className="font-serif text-3xl md:text-5xl text-sage-deep mb-10 text-center" data-id="element-216">
            Tu cuerpo no está roto, está saturado.
          </h2>
          <div className="max-w-3xl mx-auto" data-id="element-217">
            <p className="text-lg md:text-xl text-ink-soft leading-relaxed mb-8 text-center" data-id="element-218">
              Desde la sartén donde cocinas hasta el champú que usas, estás
              inhalando y absorbiendo químicos que imitan tus hormonas. Estos
              "impostores" ocupan el lugar del estrógeno y la progesterona,
              impidiendo que tu sistema dé la orden de concebir.
            </p>
            <div className="bg-blush-soft rounded-2xl p-8 md:p-10 mt-10" data-id="element-219">
              <p className="text-xl md:text-2xl font-serif text-accent italic text-center" data-id="element-220">
                "Si el balde tóxico está lleno, la fertilidad se apaga."
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}